// import { useState, useRef, useEffect } from "react";

// const CollapsibleText = ({ children, lines = 2 }) => {
//   const [expanded, setExpanded] = useState(false);
//   const [isTruncated, setIsTruncated] = useState(false);
//   const contentRef = useRef(null);

//   useEffect(() => {
//     const el = contentRef.current;

//     if (!el) return;

//     const computeTruncation = () => {
//       const lineHeight = parseFloat(getComputedStyle(el).lineHeight || "20");
//       const maxHeight = lines * lineHeight;
//       setIsTruncated(el.scrollHeight > maxHeight);
//     };

//     computeTruncation();

//     // Optional: re-calculate on resize
//     const observer = new ResizeObserver(computeTruncation);
//     observer.observe(el);

//     return () => observer.disconnect();
//   }, [children, lines]);

//   return (
//     <div style={{ position: "relative" }}>
//     <div
//       ref={contentRef}
//       style={{
//         overflow: "hidden",
//         display: "-webkit-box",
//         WebkitLineClamp: expanded ? "none" : lines,
//         WebkitBoxOrient: "vertical",
//       }}
//     >
//       {children}
//       {isTruncated && !expanded && (
//         <span
//           style={{
//             position: "absolute",
//             bottom: 0,
//             right: 0,
//             background: "white",
//             paddingLeft: 5,
//             color: "#0071E3",
//             cursor: "pointer",
//           }}
//           className="see-more-link"
//           onClick={() => setExpanded(true)}
//         >
//           ... See more
//         </span>
//       )}
//     </div>

//     {isTruncated && expanded && (
//       <span
//         onClick={() => setExpanded(false)}
//         className="see-more-link"
//         style={{ color: "#0071E3", cursor: "pointer", display: "inline-block", marginTop: 4 }}
//       >
//         See less
//       </span>
//     )}
//   </div>
//   );
// };

// export default CollapsibleText;


import { useState, useRef, useEffect } from "react";

const CollapsibleText = ({
  children,
  lines = 2,
  color = "#0071E3",
  bgColor = "white",
  showToggleOnNewLine = false,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const computeTruncation = () => {
      const lineHeight = parseFloat(getComputedStyle(el).lineHeight || "20");
      const maxHeight = lines * lineHeight;
      setIsTruncated(el.scrollHeight > maxHeight);
    };

    computeTruncation();

    const observer = new ResizeObserver(computeTruncation);
    observer.observe(el);

    return () => observer.disconnect();
  }, [children, lines]);

  return (
    <div style={{ position: "relative" }}>
      <div
        ref={contentRef}
        style={{
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: expanded ? "none" : lines,
          WebkitBoxOrient: "vertical",
          textAlign: "justify",
        }}
      >
        {children}
      </div>

      {isTruncated && !expanded && (
        <div
          style={{
            marginTop: showToggleOnNewLine ? 4 : 0,
            display: showToggleOnNewLine ? "block" : "inline",
            position: showToggleOnNewLine ? "static" : "absolute",
            bottom: showToggleOnNewLine ? "auto" : 0,
            right: showToggleOnNewLine ? "auto" : 0,
            background: bgColor,
            paddingLeft: showToggleOnNewLine ? 0 : 5,
            color: color,
            cursor: "pointer",
            textDecoration:showToggleOnNewLine &&"underline"
          }}
          className="see-more-link"
          onClick={() => setExpanded(true)}
        >
       {showToggleOnNewLine ? "Read More": "... Read More"}
        </div>
      )}

      {isTruncated && expanded && (
        <div
          onClick={() => setExpanded(false)}
          className="see-more-link"
          style={{
            color: color,
            cursor: "pointer",
            display: showToggleOnNewLine ? "block" : "inline",
            marginTop: 4,
             textDecoration:showToggleOnNewLine && "underline"
          }}
        >
          Read Less
        </div>
      )}
    </div>
  );
};

export default CollapsibleText;
